import { Component, OnInit } from '@angular/core';
import { RecruitmentApiService } from '../../services/recruitment-api.service';
import { AssessmentAvailability, RecruitmentCandidate } from '../models/recruitment.models';

@Component({
  selector: 'app-candidate-list',
  templateUrl: './candidate-list.component.html',
  styleUrls: ['./candidate-list.component.css'],
  standalone: false,
})
export class CandidateListComponent implements OnInit {
  candidates: RecruitmentCandidate[] = [];
  totalCandidates = 0;
  loading = true;
  errorMessage = '';
  search = '';
  assessmentFilter: AssessmentAvailability | 'ALL' = 'ALL';

  constructor(private recruitmentApi: RecruitmentApiService) {}

  ngOnInit(): void {
    this.loadCandidates();
  }

  loadCandidates(): void {
    this.loading = true;
    this.errorMessage = '';
    this.recruitmentApi.getCandidates({
      search: this.search,
      assessment: this.assessmentFilter,
      limit: 25,
    }).subscribe({
      next: (response) => {
        this.candidates = response.items;
        this.totalCandidates = response.total;
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'The organization talent pool could not be loaded.';
        this.loading = false;
      },
    });
  }

  initials(candidate: RecruitmentCandidate): string {
    return `${candidate.firstName.charAt(0)}${candidate.lastName.charAt(0)}`.toUpperCase();
  }
}
